import { render, staticRenderFns } from "./ModalRemito.vue?vue&type=template&id=060dc33e&"
import script from "./ModalRemito.vue?vue&type=script&lang=js&"
export * from "./ModalRemito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports